<template lang="pug">
div
    app-collapse(title="Denominação do imóvel")
      .breakText
        el-row#denominacao-imovel
          app-display(
            label="Denominação:",
            :content="imovel.denominacao"
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouDenominacao ? 'text': '' "
          )
          app-display(
            label="Município:",
            :content="imovel.municipio ? imovel.municipio.nome : ''",
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouMunicipio ? 'text': '' "
          )
          app-display(
            label="Área:",
            :content="imovel.formattedValueArea !== '0,0000 hectare(s)' ? getArea() : ''",
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouArea ? 'text': '' "
          )
    app-collapse(title="Dados do título/Matrícula")
      el-row
      .breakText
        el-col(:span="12")
          app-display(
            label="CNS:",
            :content="getValue(imovel.cnsMatricula)"
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouCNSMatricula ? 'text': '' "
          )
          app-display(
            label="Número:",
            :content="getValue(imovel.numeroMatricula)"
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouNumeroMatricula ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="Livro:",
            :content="getValue(imovel.livroMatricula)"
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouLivroMatricula ? 'text': '' "
          )
          app-display(
            label="N° da folha:",
            :content="getValue(imovel.numeroFolhaMatricula)"
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouNumeroFolhaMatricula ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="Data do registro:",
            :content="formatDate(imovel.dataRegistro)"
          )
        el-col(:span="12")
          app-display(
            label="Nome do cartório:",
            :content="getValue(imovel.nomeCartorio)"
          )
        el-col(:span="12")
          app-display(
            label="Município do cartório:",
            :content="imovel.municipioCartorio.nome"
          )
        el-col(:span="12")
          app-display(
            label="Nome do beneficiário:",
            :content="getValue(imovel.nomeBeneficiarioTitulo)"
            :class = "compararImovelCancelamento && compararImovelCancelamento.mudouNomeBeneficiarioTitulo ? 'text': '' "
          )
        el-col(:span="12")
          app-display(
            label="N° do processo físico:",
            :content="getValue(dadosProcessoFisico.numeroProcesso)"
          )
        el-col(:span="12")
          app-display(
            label="N° do título:",
            :content="getValue(dadosProcessoFisico.numeroTituloDominial)"
          )
        el-col(:span="12")
          app-display(
            label="Data emissão do título:",
            :content="formatDate(dadosProcessoFisico.dataEmissaoTituloDominial)"
          )
</template>
<script>
import utils from '@/utils/utils'
import AppDisplay from '@/components/AppDisplay'
import AppCollapse from '@/components/AppCollapse'
import InfoMatricula from '@/components/informacoesCadastro/common/InfoMatricula'

export default {
  components: {
    AppDisplay,
    InfoMatricula,
    AppCollapse
  },
  props: {
    imovel: {
      type: Object,
      required: true
    },

    dadosProcessoFisico: {
      type: Object,
      required: true
    },
    compararImovelCancelamento: {
      type: Object,
      required: true
    }
  },
  methods: {
    getArea () {
      return this.imovel.formattedValueArea !== undefined ? this.imovel.formattedValueArea : this.imovel.area + ' hectare(s)'
    },
    getValue (params) {
      return params || '-'
    },

    formatDate (value) {
      return value ? utils.formatDate(value) : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.breakText {
  word-break: break-all;
}
>>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/cadastrosOnline/cancelamentoClausula/InformacoesImovelCancelamento.vue